import { render, staticRenderFns } from "./ErpSettings.vue?vue&type=template&id=d615297a"
import script from "./ErpSettings.vue?vue&type=script&lang=js"
export * from "./ErpSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports